import React, { Component } from 'react';
import Block from  './components/Block';


var SelectSpecialties = React.createClass({
  getInitialState: function(){
    return {
      open: false
    }
  },
  // componentWillReceiveProps: function(nextProps) {
  //   this.setState({specialties: this.changeSpecialtiesActivesList(nextProps.specialties)});
  // },
  // changeSpecialtiesActivesList: function(specialties){
  //   var allSpecialties = this.props.listSpecialties,
  //       newSpecialties = [ ...allSpecialties ];

  //   for (var i = 0; i < allSpecialties.length; i++) {
  //     for (var i2 = 0; i2 < specialties.length; i2++) {
  //       if(allSpecialties[i].value == specialties[i2].value){
  //         newSpecialties[i].active = true;
  //       }
  //     }
  //   }
  //   return newSpecialties;
  // },
  // getListActiveSpecialties: function(){
  //   var activeSpecialties = [];
  //   for(var i = 0, l = this.state.specialties.length; i < l; i++){
  //     if(this.state.specialties[i].active){
  //       delete this.state.specialties[i].active;
  //       activeSpecialties[activeSpecialties.length] = this.state.specialties[i];
  //     }
  //   }
  //   return activeSpecialties;
  // },
  handlerAddSpecialty: function(id){

    console.log('this.props.specialties[id]', this.props.specialties[id])
    this.props.onSelectSpecialty(this.props.specialties[id])

    this.openOrClose();
  },
  openOrClose: function(){
    // this.props.saveSpecialties(this.getListActiveSpecialties());
    if(!this.props.specialtyError){
      this.setState({open: !this.state.open})
    }
    
  },
  render: function(){
    if(this.state.open){
      return(
        <div className="Specialties" style={{width: '80%'}}>
          {/* <div onClick={this.openOrClose} className="block save">Сохранить</div> */}
          {this.props.specialties.map((specialty, i, l) => {
            return(
              <Block key={i} id={i} active={specialty.test ? false : true} addSpecialty={this.handlerAddSpecialty}>{specialty.VacancyName}</Block>
            );
          })}
        </div>
      );
    }else{
      return(
        <div onClick={this.openOrClose} className="SelectSpecialtiesOpen">{this.props.activeSpecialti ? this.props.activeSpecialti.VacancyName : this.props.specialtyError ? 'У всех специальностей есть тесты' : 'Выберите специальность'}</div>
      );
    }
  }
});

export default SelectSpecialties;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanelTest/components/SelectSpecialties/index.jsx
 **/